/* eslint-disable */
export const Countries = [
  { id: 'United_States_of_America', name: 'United States of America', code: 'US' },
  { id: 'Afghanistan', name: 'Afghanistan', code: 'AF' },
  { id: 'Aland_Islands', name: 'Aland Islands', code: 'AX' },
  { id: 'Albania', name: 'Albania', code: 'AL' },
  { id: 'Algeria', name: 'Algeria', code: 'DZ' },
  { id: 'American_Samoa', name: 'American Samoa', code: 'AS' },
  { id: 'Andorra', name: 'Andorra', code: 'AD' },
  { id: 'Angola', name: 'Angola', code: 'AO' },
  { id: 'Anguilla', name: 'Anguilla', code: 'AI' },
  { id: 'Antarctica', name: 'Antarctica', code: 'AQ' },
  { id: 'Antigua_and_Barbuda', name: 'Antigua and Barbuda', code: 'AG' },
  { id: 'Argentina', name: 'Argentina', code: 'AR' },
  { id: 'Armenia', name: 'Armenia', code: 'AM' },
  { id: 'Aruba', name: 'Aruba', code: 'AW' },
  { id: 'Australia', name: 'Australia', code: 'AU' },
  { id: 'Austria', name: 'Austria', code: 'AT' },
  { id: 'Azerbaijan', name: 'Azerbaijan', code: 'AZ' },
  { id: 'Bahamas', name: 'Bahamas', code: 'BS' },
  { id: 'Bahrain', name: 'Bahrain', code: 'BH' },
  { id: 'Bangladesh', name: 'Bangladesh', code: 'BD' },
  { id: 'Barbados', name: 'Barbados', code: 'BB' },
  { id: 'Belarus', name: 'Belarus', code: 'BY' },
  { id: 'Belgium', name: 'Belgium', code: 'BE' },
  { id: 'Belize', name: 'Belize', code: 'BZ' },
  { id: 'Benin', name: 'Benin', code: 'BJ' },
  { id: 'Bermuda', name: 'Bermuda', code: 'BM' },
  { id: 'Bhutan', name: 'Bhutan', code: 'BT' },
  { id: 'Bolivia', name: 'Bolivia', code: 'BO' },
  { id: 'Bosnia_And_Herzegovina', name: 'Bosnia and Herzegovina', code: 'BA' },
  { id: 'Botswana', name: 'Botswana', code: 'BW' },
  { id: 'Brazil', name: 'Brazil', code: 'BR' },
  { id: 'British_Indian_Ocean_Territory', name: 'British Indian Ocean Territory', code: 'IO' },
  { id: 'Brunei', name: 'Brunei', code: 'BN' },
  { id: 'Bulgaria', name: 'Bulgaria', code: 'BG' },
  { id: 'Burkina_Faso', name: 'Burkina Faso', code: 'BF' },
  { id: 'Burundi', name: 'Burundi', code: 'BI' },
  { id: 'Cambodia', name: 'Cambodia', code: 'KH' },
  { id: 'Cameroon', name: 'Cameroon', code: 'CM' },
  { id: 'Canada', name: 'Canada', code: 'CA' },
  { id: 'Cape_Verde', name: 'Cape Verde', code: 'CV' },
  { id: 'Caribbean_Netherlands', name: 'Caribbean Netherlands', code: 'BQ' },
  { id: 'Cayman_Islands', name: 'Cayman Islands', code: 'KY' },
  { id: 'Central_African_Republic', name: 'Central African Republic', code: 'CF' },
  { id: 'Chad', name: 'Chad', code: 'TD' },
  { id: 'Chile', name: 'Chile', code: 'CL' },
  { id: 'China', name: 'China', code: 'CN' },
  { id: 'Christmas_Island_(Indian)', name: 'Christmas Island (Indian)', code: 'CX' },
  { id: 'Cocos_(Keeling)_Islands', name: 'Cocos (Keeling) Islands', code: 'CC' },
  { id: 'Colombia', name: 'Colombia', code: 'CO' },
  { id: 'Comoros', name: 'Comoros', code: 'KM' },
  { id: 'Congo', name: 'Congo', code: 'CG' },
  { id: 'Congo_(DRC)', name: 'Congo (DRC)', code: 'CD' },
  { id: 'Cook_Islands', name: 'Cook Islands', code: 'CK' },
  { id: 'Costa_Rica', name: 'Costa Rica', code: 'CR' },
  { id: 'Cote_dIvoire', name: 'Cote d\'Ivoire (Ivory Coast)', code: 'CI' },
  { id: 'Croatia', name: 'Croatia', code: 'HR' },
  { id: 'Cuba', name: 'Cuba', code: 'CU' },
  { id: 'Curacao', name: 'Curacao', code: 'CW' },
  { id: 'Cyprus', name: 'Cyprus', code: 'CY' },
  { id: 'Czech_Republic', name: 'Czech Republic', code: 'CZ' },
  { id: 'Denmark', name: 'Denmark', code: 'DK' },
  { id: 'Djibouti', name: 'Djibouti', code: 'DJ' },
  { id: 'Dominica', name: 'Dominica', code: 'DM' },
  { id: 'Dominican_Republic', name: 'Dominican Republic', code: 'DO' },
  { id: 'East_Timor', name: 'East Timor', code: 'TL' },
  { id: 'Ecuador', name: 'Ecuador', code: 'EC' },
  { id: 'Egypt', name: 'Egypt', code: 'EG' },
  { id: 'El_Salvador', name: 'El Salvador', code: 'SV' },
  { id: 'Equatorial_Guinea', name: 'Equatorial Guinea', code: 'GQ' },
  { id: 'Eritrea', name: 'Eritrea', code: 'ER' },
  { id: 'Estonia', name: 'Estonia', code: 'EE' },
  { id: 'Ethiopia', name: 'Ethiopia', code: 'ET' },
  { id: 'Falkland_Islands', name: 'Falkland Islands', code: 'FK' },
  { id: 'Faroe_Islands', name: 'Faroe Islands', code: 'FO' },
  { id: 'Fiji', name: 'Fiji', code: 'FJ' },
  { id: 'Finland', name: 'Finland', code: 'FI' },
  { id: 'France', name: 'France', code: 'FR' },
  { id: 'French_Guiana', name: 'French Guiana', code: 'GF' },
  { id: 'French_Polynesia_(Tahiti)', name: 'French Polynesia, Tahiti', code: 'PF' },
  { id: 'French_Southern_and_Antarctic', name: 'French Southern and Antarctic', code: 'TF' },
  { id: 'Gabon', name: 'Gabon', code: 'GA' },
  { id: 'Gambia', name: 'Gambia, The', code: 'GM' },
  { id: 'Georgia', name: 'Georgia', code: 'GE' },
  { id: 'Germany', name: 'Germany', code: 'DE' },
  { id: 'Ghana', name: 'Ghana', code: 'GH' },
  { id: 'Gibraltar', name: 'Gibraltar', code: 'GI' },
  { id: 'Greece', name: 'Greece', code: 'GR' },
  { id: 'Greenland', name: 'Greenland', code: 'GL' },
  { id: 'Grenada_(Southern_Grenadines)', name: 'Grenada (Southern Grenadines)', code: 'GD' },
  { id: 'Guadeloupe', name: 'Guadeloupe', code: 'GP' },
  { id: 'Guatemala', name: 'Guatemala', code: 'GT' },
  { id: 'Guernsey', name: 'Guernsey', code: 'GG' },
  { id: 'Guinea', name: 'Guinea', code: 'GN' },
  { id: 'Guinea_Bissau', name: 'Guinea - Bissau', code: 'GW' },
  { id: 'Guyana', name: 'Guyana', code: 'GY' },
  { id: 'Haiti', name: 'Haiti', code: 'HT' },
  { id: 'Honduras', name: 'Honduras', code: 'HN' },
  { id: 'Hong_Kong', name: 'Hong Kong', code: 'HK' },
  { id: 'Hungary', name: 'Hungary', code: 'HU' },
  { id: 'Iceland', name: 'Iceland', code: 'IS' },
  { id: 'India', name: 'India', code: 'IN' },
  { id: 'Indonesia_(Bali_Belitung_Flores_Java_etc.)', name: 'Indonesia (Bali, Belitung, Flores, Java, etc.)', code: 'ID' },
  { id: 'Iran', name: 'Iran', code: 'IR' },
  { id: 'Iraq', name: 'Iraq', code: 'IQ' },
  { id: 'Ireland', name: 'Ireland', code: 'IE' },
  { id: 'Isle_of_Man', name: 'Isle of Man', code: 'IM' },
  { id: 'Israel', name: 'Israel', code: 'IL' },
  { id: 'Italy', name: 'Italy', code: 'IT' },
  { id: 'Jamaica', name: 'Jamaica', code: 'JM' },
  { id: 'Jan_Mayen', name: 'Jan Mayen', code: 'SJ' }, // BE/MW has one entry for Svalbard and Jan Mayen
  { id: 'Japan_Ryukyu_Islands', name: 'Japan, Ryukyu Islands', code: 'JP' },
  { id: 'Jersey', name: 'Jersey', code: 'JE' },
  { id: 'Jordan', name: 'Jordan', code: 'JO' },
  { id: 'Kazakhstan', name: 'Kazakhstan', code: 'KZ' },
  { id: 'Kenya', name: 'Kenya', code: 'KE' },
  { id: 'Kiribati_(Gilbert_Islands)', name: 'Kiribati (Gilbert Islands)', code: 'KI' },
  { id: 'Kosovo', name: 'Kosovo', code: 'XK' },
  { id: 'Kuwait', name: 'Kuwait', code: 'KW' },
  { id: 'Kyrgyzstan', name: 'Kyrgyzstan', code: 'KG' },
  { id: 'Laos', name: 'Laos', code: 'LA' },
  { id: 'Latvia', name: 'Latvia', code: 'LV' },
  { id: 'Lebanon', name: 'Lebanon', code: 'LB' },
  { id: 'Lesotho', name: 'Lesotho', code: 'LS' },
  { id: 'Liberia', name: 'Liberia', code: 'LR' },
  { id: 'Libya', name: 'Libya', code: 'LY' },
  { id: 'Liechtenstein', name: 'Liechtenstein', code: 'LI' },
  { id: 'Lithuania', name: 'Lithuania', code: 'LT' },
  { id: 'Luxembourg', name: 'Luxembourg', code: 'LU' },
  { id: 'Macau', name: 'Macau', code: 'MO' },
  { id: 'Macedonia', name: 'Macedonia', code: 'MK' },
  { id: 'Madagascar', name: 'Madagascar', code: 'MG' },
  { id: 'Malawi', name: 'Malawi', code: 'MW' },
  { id: 'Malaysia', name: 'Malaysia', code: 'MY' },
  { id: 'Maldives', name: 'Maldives', code: 'MV' },
  { id: 'Mali', name: 'Mali', code: 'ML' },
  { id: 'Malta', name: 'Malta', code: 'MT' },
  { id: 'Marshall_Islands', name: 'Marshall Islands', code: 'MH' },
  { id: 'Martinique', name: 'Martinique', code: 'MQ' },
  { id: 'Mauritania', name: 'Mauritania', code: 'MR' },
  { id: 'Mauritius', name: 'Mauritius', code: 'MU' },
  { id: 'Mayotte', name: 'Mayotte', code: 'YT' },
  { id: 'Mexico', name: 'Mexico', code: 'MX' },
  { id: 'Micronesia', name: 'Micronesia', code: 'FM' },
  { id: 'Moldova', name: 'Moldova', code: 'MD' },
  { id: 'Monaco', name: 'Monaco', code: 'MC' },
  { id: 'Mongolia', name: 'Mongolia', code: 'MN' },
  { id: 'Montenegro', name: 'Montenegro', code: 'ME' },
  { id: 'Montserrat', name: 'Montserrat', code: 'MS' },
  { id: 'Morocco', name: 'Morocco', code: 'MA' },
  { id: 'Mozambique', name: 'Mozambique', code: 'MZ' },
  { id: 'Myanmar', name: 'Myanmar (Burma)', code: 'MM' },
  { id: 'Namibia', name: 'Namibia', code: 'NA' },
  { id: 'Nauru', name: 'Nauru', code: 'NR' },
  { id: 'Nepal', name: 'Nepal', code: 'NP' },
  { id: 'Netherlands', name: 'Netherlands', code: 'NL' },
  { id: 'New_Caledonia', name: 'New Caledonia', code: 'NC' },
  { id: 'New_Zealand', name: 'New Zealand', code: 'NZ' },
  { id: 'Nicaragua', name: 'Nicaragua', code: 'NI' },
  { id: 'Niger', name: 'Niger', code: 'NE' },
  { id: 'Nigeria', name: 'Nigeria', code: 'NG' },
  { id: 'Niue', name: 'Niue', code: 'NU' },
  { id: 'Norfolk_Island', name: 'Norfolk Island', code: 'NF' },
  { id: 'North_Korea', name: 'North Korea', code: 'KP' },
  { id: 'Norway', name: 'Norway', code: 'NO' },
  { id: 'Oman', name: 'Oman', code: 'OM' },
  { id: 'Pakistan', name: 'Pakistan', code: 'PK' },
  { id: 'Palau', name: 'Palau', code: 'PW' },
  { id: 'Palestine', name: 'Palestine', code: 'PS' },
  { id: 'Panama', name: 'Panama', code: 'PA' },
  { id: 'Papua_New_Guinea', name: 'Papua New Guinea', code: 'PG' },
  { id: 'Paraguay', name: 'Paraguay', code: 'PY' },
  { id: 'Peru', name: 'Peru', code: 'PE' },
  { id: 'Philippines', name: 'Philippines', code: 'PH' },
  { id: 'Pitcairn_Islands', name: 'Pitcairn Islands', code: 'PN' },
  { id: 'Poland', name: 'Poland', code: 'PL' },
  { id: 'Portugal', name: 'Portugal', code: 'PT' },
  { id: 'Qatar', name: 'Qatar', code: 'QA' },
  { id: 'Reunion', name: 'Reunion', code: 'RE' },
  { id: 'Romania', name: 'Romania', code: 'RO' },
  { id: 'Russia', name: 'Russia', code: 'RU' },
  { id: 'Rwanda', name: 'Rwanda', code: 'RW' },
  { id: 'San_Marino', name: 'San Marino', code: 'SM' },
  { id: 'Sao_Tome_and_Principe', name: 'Sao Tome and Principe', code: 'ST' },
  { id: 'Saudi_Arabia', name: 'Saudi Arabia', code: 'SA' },
  { id: 'Senegal', name: 'Senegal', code: 'SN' },
  { id: 'Serbia', name: 'Serbia', code: 'RS' },
  { id: 'Seychelles', name: 'Seychelles', code: 'SC' },
  { id: 'Sierra_Leone', name: 'Sierra Leone', code: 'SL' },
  { id: 'Singapore', name: 'Singapore', code: 'SG' },
  { id: 'Sint_Maarten', name: 'Sint Maarten', code: 'SX' },
  { id: 'Slovak_Republic', name: 'Slovak Republic', code: 'SK' },
  { id: 'Slovenia', name: 'Slovenia', code: 'SI' },
  { id: 'Solomon_Islands', name: 'Solomon Islands', code: 'SB' },
  { id: 'Somalia', name: 'Somalia', code: 'SO' },
  { id: 'South_Africa', name: 'South Africa', code: 'ZA' },
  { id: 'South_Georgia_and_South_Sandwich_Islands', name: 'South Georgia and South Sandwich Islands', code: 'GS' },
  { id: 'South_Korea', name: 'South Korea', code: 'KR' },
  { id: 'South_Sudan', name: 'South Sudan', code: 'SS' },
  { id: 'Spain', name: 'Spain', code: 'ES' },
  { id: 'Sri_Lanka', name: 'Sri Lanka', code: 'LK' },
  { id: 'St_Barthelemy', name: 'St. Barthelemy', code: 'BL' },
  { id: 'St_Helena', name: 'St. Helena', code: 'SH' },
  { id: 'St_Kitts_(St_Christopher_and_Nevis)', name: 'St. Kitts (St Christopher and Nevis)', code: 'KN' },
  { id: 'St_Lucia', name: 'St. Lucia', code: 'LC' },
  { id: 'St_Martin', name: 'St. Martin', code: 'MF' },
  { id: 'St_Pierre_and_Miquelon', name: 'St. Pierre and Miquelon', code: 'PM' },
  { id: 'St_Vincent_N_Grenadines_Winward_Island', name: 'St. Vincent/ N Grenadines/ Winward Island', code: 'VC' },
  { id: 'Sudan', name: 'Sudan', code: 'SD' },
  { id: 'Suriname', name: 'Suriname', code: 'SR' },
  { id: 'Svalbard', name: 'Svalbard', code: 'SJ' }, // BE/MW has one entry for Svalbard and Jan Mayen
  { id: 'Swaziland', name: 'Swaziland', code: 'SZ' },
  { id: 'Sweden', name: 'Sweden', code: 'SE' },
  { id: 'Switzerland', name: 'Switzerland', code: 'CH' },
  { id: 'Syria', name: 'Syria', code: 'SY' },
  { id: 'Taiwan', name: 'Taiwan', code: 'TW' },
  { id: 'Tajikistan', name: 'Tajikistan', code: 'TJ' },
  { id: 'Tanzania', name: 'Tanzania', code: 'TZ' },
  { id: 'Thailand', name: 'Thailand', code: 'TH' },
  { id: 'Togo', name: 'Togo', code: 'TG' },
  { id: 'Tokelau', name: 'Tokelau', code: 'TK' },
  { id: 'Tonga', name: 'Tonga', code: 'TO' },
  { id: 'Trinidad_and_Tobago', name: 'Trinidad and Tobago', code: 'TT' },
  { id: 'Tunisia', name: 'Tunisia', code: 'TN' },
  { id: 'Turkey', name: 'Turkey', code: 'TR' },
  { id: 'Turkmenistan', name: 'Turkmenistan', code: 'TM' },
  { id: 'Turks_and_Caicos_Islands', name: 'Turks and Caicos Islands', code: 'TC' },
  { id: 'Tuvalu', name: 'Tuvalu', code: 'TV' },
  { id: 'US_Outlying_Islands', name: 'U.S. Outlying Islands', code: 'UM' },
  { id: 'Uganda', name: 'Uganda', code: 'UG' },
  { id: 'Ukraine', name: 'Ukraine', code: 'UA' },
  { id: 'United_Arab_Emirates', name: 'United Arab Emirates', code: 'AE' },
  { id: 'United_Kingdom', name: 'United Kingdom', code: 'GB' },
  { id: 'Uruguay', name: 'Uruguay', code: 'UY' },
  { id: 'Uzbekistan', name: 'Uzbekistan', code: 'UZ' },
  { id: 'Vanuatu', name: 'Vanuatu', code: 'VU' },
  { id: 'Vatican_City', name: 'Vatican City', code: 'VA' },
  { id: 'Venezuela', name: 'Venezuela', code: 'VE' },
  { id: 'Vietnam', name: 'Vietnam', code: 'VN' },
  { id: 'Virgin_Islands_(British)', name: 'Virgin Islands (British)', code: 'VG' },
  { id: 'Wallis_and_Futuna', name: 'Wallis and Futuna', code: 'WF' },
  { id: 'Western_Sahara', name: 'Western Sahara', code: 'EH' },
  { id: 'Western_Samoa', name: 'Western Samoa', code: 'WS' },
  { id: 'Yemen_(Aden)', name: 'Yemen (Aden)', code: 'YE' },
  { id: 'Zambia', name: 'Zambia', code: 'ZM' },
  { id: 'Zimbabwe', name: 'Zimbabwe', code: 'ZW' },
];
